import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAthleteAuth } from '@/contexts/AthleteAuthContext';

interface Props {
  children: ReactNode;
}

export default function ProtectedAthleteRoute({ children }: Props) {
  const { athlete, token, isLoading, mustChangePassword } = useAthleteAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg-primary)]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-[var(--primary)] border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-[var(--text-secondary)]">載入中 / Loading...</p>
        </div>
      </div>
    );
  }

  if (!token || !athlete) {
    return <Navigate to="/athlete/login" state={{ from: location }} replace />;
  }

  if (mustChangePassword) {
    return <Navigate to="/athlete/change-password" replace />;
  }

  return <>{children}</>;
}
